import { atom } from 'jotai';


/**
 * Initial auth state
 */
export const initialAuthState = {
    isLoggedIn: false,
    userRole: '',
    email: '',
    firstName: '',
    lastName: '',
    profilePic: '',
    status: ''
}
/**
 * auth state atom
 */
export const authState = atom(initialAuthState);